//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { AUDIT_API_BASE_URL } from '../http/api-client.tokens';

export interface IClient {
  /**
   * Gets all paginated audit assessments with search and sort capabilities. Returns intervention type, NP name,
   * appointment date, age, member name, audit status, and appointment date.
   *
   * @param body (optional) The pagination request with search and sort parameters.
   * @returns OK
   */
  allAssessments(body?: AssessmentAuditPagedRequest | undefined): Observable<AssessmentAuditResponsePagedResult>;
  /**
   * Gets all paginated in-progress audit assessments (Started/Resume) assigned to the current user. Returns audits with
   * status NotStarted or Initiated.
   *
   * @param body (optional) The pagination request with search and sort parameters.
   * @returns OK
   */
  myInprogressAssessments(
    body?: AssessmentAuditPagedRequest | undefined
  ): Observable<PendingAssessmentAuditResponseAuditPagedResult>;
  /**
   * Gets all paginated completed audit assessments assigned to the current user. Returns audits with status Completed.
   *
   * @param body (optional) The pagination request with search and sort parameters.
   * @returns OK
   */
  myCompletedAssessments(
    body?: AssessmentAuditPagedRequest | undefined
  ): Observable<CompletedAssessmentAuditResponsePagedResult>;
  /**
   * Updates an existing audit record. Only `AuditStatusId`, `AuditorId`, `PublishedQuestionnaireResponseId`, and
   * `Score` may be changed. `AuditRowId` in the request body is required and must correspond to an active audit.
   *
   * @param body (optional) The update payload.
   * @returns No Content
   */
  assessments(body?: UpdateAuditRequest | undefined): Observable<void>;
  /**
   * Assigns an auditor to one or more audit records. Only users with UserType `AuditManager` are permitted to call this
   * endpoint. Updates only the `AuditorId` field of the specified audits. Supports bulk assignment by accepting
   * multiple audit row IDs.
   *
   * @param body (optional) The assign auditor payload containing AuditRowIds and AuditorId.
   * @returns OK
   */
  assignAuditor(body?: AssignAuditorRequest | undefined): Observable<boolean>;
  /**
   * Starts an audit by resolving its questionnaire ID from the client template configuration, then transitions the
   * audit status to Initiated. Returns 404 with a typed error body if the audit record is not found or if no template
   * is configured for this client — in the latter case the audit status remains NotStarted.
   *
   * @param assessmentAuditRowId The assessment audit row identifier.
   * @returns OK
   */
  fhirQuestionnaireIds(assessmentAuditRowId: number): Observable<QuestionnaireIdsResponse>;
  /**
   * Gets the current audit score summary with a static dummy value.
   *
   * @returns OK
   */
  scoreSummary(): Observable<AuditScoreSummaryResponse>;
  /**
   * Gets dashboard assessment audits filtered by year, quarters, vendors, and intervention types. Returns the same
   * assessment audit data as GetAllAssessments but with dashboard-specific filtering.
   *
   * @param year (optional)
   * @param quarters (optional)
   * @param vendorIds (optional)
   * @returns OK
   */
  assessmentAudits(
    year?: number | undefined,
    quarters?: number[] | undefined,
    vendorIds?: number[] | undefined
  ): Observable<AuditedAssessmentResponse[]>;
  /**
   * Gets the available years for assessment audits to populate the dashboard year filter dropdown.
   *
   * @returns OK
   */
  availableYears(): Observable<number[]>;
  /**
   * Manually triggers the audit pipeline (dump + assign). Intended for testing and manual execution in lower
   * environments.
   *
   * @returns OK
   */
  trigger(): Observable<AuditPipelineResult>;
  /** @returns OK */
  health(): Observable<void>;
  /** @returns OK */
  detailed(): Observable<HealthCheckResponse>;
}

@Injectable()
export class Client implements IClient {
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  private http = inject(HttpClient);
  private baseUrl = inject<string>(AUDIT_API_BASE_URL);

  /**
   * Gets all paginated audit assessments with search and sort capabilities. Returns intervention type, NP name,
   * appointment date, age, member name, audit status, and appointment date.
   *
   * @param body (optional) The pagination request with search and sort parameters.
   * @returns OK
   */
  allAssessments(body?: AssessmentAuditPagedRequest | undefined): Observable<AssessmentAuditResponsePagedResult> {
    let url_ = this.baseUrl + '/api/Audit/all-assessments';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAllAssessments(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAllAssessments(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AssessmentAuditResponsePagedResult>;
            }
          } else return _observableThrow(response_) as any as Observable<AssessmentAuditResponsePagedResult>;
        })
      );
  }

  protected processAllAssessments(response: HttpResponseBase): Observable<AssessmentAuditResponsePagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AssessmentAuditResponsePagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets all paginated in-progress audit assessments (Started/Resume) assigned to the current user. Returns audits with
   * status NotStarted or Initiated.
   *
   * @param body (optional) The pagination request with search and sort parameters.
   * @returns OK
   */
  myInprogressAssessments(
    body?: AssessmentAuditPagedRequest | undefined
  ): Observable<PendingAssessmentAuditResponseAuditPagedResult> {
    let url_ = this.baseUrl + '/api/Audit/my-inprogress-assessments';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMyInprogressAssessments(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMyInprogressAssessments(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PendingAssessmentAuditResponseAuditPagedResult>;
            }
          } else
            return _observableThrow(response_) as any as Observable<PendingAssessmentAuditResponseAuditPagedResult>;
        })
      );
  }

  protected processMyInprogressAssessments(
    response: HttpResponseBase
  ): Observable<PendingAssessmentAuditResponseAuditPagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PendingAssessmentAuditResponseAuditPagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets all paginated completed audit assessments assigned to the current user. Returns audits with status Completed.
   *
   * @param body (optional) The pagination request with search and sort parameters.
   * @returns OK
   */
  myCompletedAssessments(
    body?: AssessmentAuditPagedRequest | undefined
  ): Observable<CompletedAssessmentAuditResponsePagedResult> {
    let url_ = this.baseUrl + '/api/Audit/my-completed-assessments';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMyCompletedAssessments(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMyCompletedAssessments(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CompletedAssessmentAuditResponsePagedResult>;
            }
          } else return _observableThrow(response_) as any as Observable<CompletedAssessmentAuditResponsePagedResult>;
        })
      );
  }

  protected processMyCompletedAssessments(
    response: HttpResponseBase
  ): Observable<CompletedAssessmentAuditResponsePagedResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CompletedAssessmentAuditResponsePagedResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Updates an existing audit record. Only `AuditStatusId`, `AuditorId`, `PublishedQuestionnaireResponseId`, and
   * `Score` may be changed. `AuditRowId` in the request body is required and must correspond to an active audit.
   *
   * @param body (optional) The update payload.
   * @returns No Content
   */
  assessments(body?: UpdateAuditRequest | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/Audit/assessments';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAssessments(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAssessments(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAssessments(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Assigns an auditor to one or more audit records. Only users with UserType `AuditManager` are permitted to call this
   * endpoint. Updates only the `AuditorId` field of the specified audits. Supports bulk assignment by accepting
   * multiple audit row IDs.
   *
   * @param body (optional) The assign auditor payload containing AuditRowIds and AuditorId.
   * @returns OK
   */
  assignAuditor(body?: AssignAuditorRequest | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/Audit/assessments/assign-auditor';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAssignAuditor(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAssignAuditor(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processAssignAuditor(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : (null as any);

          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Starts an audit by resolving its questionnaire ID from the client template configuration, then transitions the
   * audit status to Initiated. Returns 404 with a typed error body if the audit record is not found or if no template
   * is configured for this client — in the latter case the audit status remains NotStarted.
   *
   * @param assessmentAuditRowId The assessment audit row identifier.
   * @returns OK
   */
  fhirQuestionnaireIds(assessmentAuditRowId: number): Observable<QuestionnaireIdsResponse> {
    let url_ = this.baseUrl + '/api/Audit/fhir-questionnaire-ids/{assessmentAuditRowId}';
    if (assessmentAuditRowId === undefined || assessmentAuditRowId === null)
      throw new globalThis.Error("The parameter 'assessmentAuditRowId' must be defined.");
    url_ = url_.replace('{assessmentAuditRowId}', encodeURIComponent('' + assessmentAuditRowId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFhirQuestionnaireIds(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFhirQuestionnaireIds(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<QuestionnaireIdsResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<QuestionnaireIdsResponse>;
        })
      );
  }

  protected processFhirQuestionnaireIds(response: HttpResponseBase): Observable<QuestionnaireIdsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = QuestionnaireIdsResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets the current audit score summary with a static dummy value.
   *
   * @returns OK
   */
  scoreSummary(): Observable<AuditScoreSummaryResponse> {
    let url_ = this.baseUrl + '/api/Audit/score-summary';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processScoreSummary(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processScoreSummary(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AuditScoreSummaryResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<AuditScoreSummaryResponse>;
        })
      );
  }

  protected processScoreSummary(response: HttpResponseBase): Observable<AuditScoreSummaryResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AuditScoreSummaryResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets dashboard assessment audits filtered by year, quarters, vendors, and intervention types. Returns the same
   * assessment audit data as GetAllAssessments but with dashboard-specific filtering.
   *
   * @param year (optional)
   * @param quarters (optional)
   * @param vendorIds (optional)
   * @returns OK
   */
  assessmentAudits(
    year?: number | undefined,
    quarters?: number[] | undefined,
    vendorIds?: number[] | undefined
  ): Observable<AuditedAssessmentResponse[]> {
    let url_ = this.baseUrl + '/api/Audit/assessment-audits?';
    if (year === null) throw new globalThis.Error("The parameter 'year' cannot be null.");
    else if (year !== undefined) url_ += 'Year=' + encodeURIComponent('' + year) + '&';
    if (quarters === null) throw new globalThis.Error("The parameter 'quarters' cannot be null.");
    else if (quarters !== undefined)
      quarters &&
        quarters.forEach((item) => {
          url_ += 'Quarters=' + encodeURIComponent('' + item) + '&';
        });
    if (vendorIds === null) throw new globalThis.Error("The parameter 'vendorIds' cannot be null.");
    else if (vendorIds !== undefined)
      vendorIds &&
        vendorIds.forEach((item) => {
          url_ += 'VendorIds=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAssessmentAudits(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAssessmentAudits(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AuditedAssessmentResponse[]>;
            }
          } else return _observableThrow(response_) as any as Observable<AuditedAssessmentResponse[]>;
        })
      );
  }

  protected processAssessmentAudits(response: HttpResponseBase): Observable<AuditedAssessmentResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(AuditedAssessmentResponse.fromJS(item));
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Gets the available years for assessment audits to populate the dashboard year filter dropdown.
   *
   * @returns OK
   */
  availableYears(): Observable<number[]> {
    let url_ = this.baseUrl + '/api/Audit/available-years';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAvailableYears(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAvailableYears(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number[]>;
            }
          } else return _observableThrow(response_) as any as Observable<number[]>;
        })
      );
  }

  protected processAvailableYears(response: HttpResponseBase): Observable<number[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(item);
          } else {
            result200 = null as any;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Manually triggers the audit pipeline (dump + assign). Intended for testing and manual execution in lower
   * environments.
   *
   * @returns OK
   */
  trigger(): Observable<AuditPipelineResult> {
    let url_ = this.baseUrl + '/api/Audit/pipeline/trigger';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTrigger(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTrigger(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AuditPipelineResult>;
            }
          } else return _observableThrow(response_) as any as Observable<AuditPipelineResult>;
        })
      );
  }

  protected processTrigger(response: HttpResponseBase): Observable<AuditPipelineResult> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AuditPipelineResult.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /** @returns OK */
  health(): Observable<void> {
    let url_ = this.baseUrl + '/health';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processHealth(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processHealth(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processHealth(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status === 503) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Service Unavailable', status, _responseText, _headers);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }

  /** @returns OK */
  detailed(): Observable<HealthCheckResponse> {
    let url_ = this.baseUrl + '/health/detailed';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDetailed(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDetailed(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<HealthCheckResponse>;
            }
          } else return _observableThrow(response_) as any as Observable<HealthCheckResponse>;
        })
      );
  }

  protected processDetailed(response: HttpResponseBase): Observable<HealthCheckResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = HealthCheckResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('No Content', status, _responseText, _headers);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = ProblemDetails.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = ProblemDetails.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = ProblemDetails.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result409: any = null;
          let resultData409 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result409 = ProblemDetails.fromJS(resultData409);
          return throwException('Conflict', status, _responseText, _headers, result409);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('Internal Server Error', status, _responseText, _headers);
        })
      );
    } else if (status === 503) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result503: any = null;
          let resultData503 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result503 = HealthCheckResponse.fromJS(resultData503);
          return throwException('Service Unavailable', status, _responseText, _headers, result503);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        })
      );
    }
    return _observableOf(null as any);
  }
}

export class AssessmentAuditPagedRequest implements IAssessmentAuditPagedRequest {
  page?: number;
  pageSize?: number;
  readonly skip?: number;
  searchSort?: SearchSortParams;
  vendorId?: number | undefined;
  clientId?: number | undefined;
  auditStatusId?: number | undefined;
  auditTypeId?: number | undefined;
  auditorId?: number | undefined;
  npName?: string | undefined;
  npi?: string | undefined;
  memberName?: string | undefined;
  memberId?: number | undefined;
  clientMemberId?: string | undefined;
  appointmentDateFrom?: string | undefined;
  appointmentDateTo?: string | undefined;

  constructor(data?: IAssessmentAuditPagedRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.page = _data['page'];
      this.pageSize = _data['pageSize'];
      (this as any).skip = _data['skip'];
      this.searchSort = _data['searchSort'] ? SearchSortParams.fromJS(_data['searchSort']) : (undefined as any);
      this.vendorId = _data['vendorId'];
      this.clientId = _data['clientId'];
      this.auditStatusId = _data['auditStatusId'];
      this.auditTypeId = _data['auditTypeId'];
      this.auditorId = _data['auditorId'];
      this.npName = _data['npName'];
      this.npi = _data['npi'];
      this.memberName = _data['memberName'];
      this.memberId = _data['memberId'];
      this.clientMemberId = _data['clientMemberId'];
      this.appointmentDateFrom = _data['appointmentDateFrom'];
      this.appointmentDateTo = _data['appointmentDateTo'];
    }
  }

  static fromJS(data: any): AssessmentAuditPagedRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AssessmentAuditPagedRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['page'] = this.page;
    data['pageSize'] = this.pageSize;
    data['skip'] = this.skip;
    data['searchSort'] = this.searchSort ? this.searchSort.toJSON() : (undefined as any);
    data['vendorId'] = this.vendorId;
    data['clientId'] = this.clientId;
    data['auditStatusId'] = this.auditStatusId;
    data['auditTypeId'] = this.auditTypeId;
    data['auditorId'] = this.auditorId;
    data['npName'] = this.npName;
    data['npi'] = this.npi;
    data['memberName'] = this.memberName;
    data['memberId'] = this.memberId;
    data['clientMemberId'] = this.clientMemberId;
    data['appointmentDateFrom'] = this.appointmentDateFrom;
    data['appointmentDateTo'] = this.appointmentDateTo;
    return data;
  }
}

export interface IAssessmentAuditPagedRequest {
  page?: number;
  pageSize?: number;
  skip?: number;
  searchSort?: SearchSortParams;
  vendorId?: number | undefined;
  clientId?: number | undefined;
  auditStatusId?: number | undefined;
  auditTypeId?: number | undefined;
  auditorId?: number | undefined;
  npName?: string | undefined;
  npi?: string | undefined;
  memberName?: string | undefined;
  memberId?: number | undefined;
  clientMemberId?: string | undefined;
  appointmentDateFrom?: string | undefined;
  appointmentDateTo?: string | undefined;
}

export class AssessmentAuditResponse implements IAssessmentAuditResponse {
  assessmentAuditRowId?: number;
  vendorID?: number;
  clientId?: number;
  lobId?: number | undefined;
  clientName?: string | undefined;
  clientMemberId!: string | undefined;
  gender!: string | undefined;
  interventionTypeId?: number | undefined;
  appointmentDate?: string | undefined;
  memberName?: string | undefined;
  memberId?: number | undefined;
  assessmentRowId?: number;
  assessmentId?: number;
  age?: number | undefined;
  auditStatusId?: number | undefined;
  auditTypeId?: number | undefined;
  npName!: string | undefined;
  npi!: string | undefined;
  auditorId?: number | undefined;
  assignedTo!: string | undefined;

  constructor(data?: IAssessmentAuditResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assessmentAuditRowId = _data['assessmentAuditRowId'];
      this.vendorID = _data['vendorID'];
      this.clientId = _data['clientId'];
      this.lobId = _data['lobId'];
      this.clientName = _data['clientName'];
      this.clientMemberId = _data['clientMemberId'];
      this.gender = _data['gender'];
      this.interventionTypeId = _data['interventionTypeId'];
      this.appointmentDate = _data['appointmentDate'];
      this.memberName = _data['memberName'];
      this.memberId = _data['memberId'];
      this.assessmentRowId = _data['assessmentRowId'];
      this.assessmentId = _data['assessmentId'];
      this.age = _data['age'];
      this.auditStatusId = _data['auditStatusId'];
      this.auditTypeId = _data['auditTypeId'];
      this.npName = _data['npName'];
      this.npi = _data['npi'];
      this.auditorId = _data['auditorId'];
      this.assignedTo = _data['assignedTo'];
    }
  }

  static fromJS(data: any): AssessmentAuditResponse {
    data = typeof data === 'object' ? data : {};
    let result = new AssessmentAuditResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['assessmentAuditRowId'] = this.assessmentAuditRowId;
    data['vendorID'] = this.vendorID;
    data['clientId'] = this.clientId;
    data['lobId'] = this.lobId;
    data['clientName'] = this.clientName;
    data['clientMemberId'] = this.clientMemberId;
    data['gender'] = this.gender;
    data['interventionTypeId'] = this.interventionTypeId;
    data['appointmentDate'] = this.appointmentDate;
    data['memberName'] = this.memberName;
    data['memberId'] = this.memberId;
    data['assessmentRowId'] = this.assessmentRowId;
    data['assessmentId'] = this.assessmentId;
    data['age'] = this.age;
    data['auditStatusId'] = this.auditStatusId;
    data['auditTypeId'] = this.auditTypeId;
    data['npName'] = this.npName;
    data['npi'] = this.npi;
    data['auditorId'] = this.auditorId;
    data['assignedTo'] = this.assignedTo;
    return data;
  }
}

export interface IAssessmentAuditResponse {
  assessmentAuditRowId?: number;
  vendorID?: number;
  clientId?: number;
  lobId?: number | undefined;
  clientName?: string | undefined;
  clientMemberId: string | undefined;
  gender: string | undefined;
  interventionTypeId?: number | undefined;
  appointmentDate?: string | undefined;
  memberName?: string | undefined;
  memberId?: number | undefined;
  assessmentRowId?: number;
  assessmentId?: number;
  age?: number | undefined;
  auditStatusId?: number | undefined;
  auditTypeId?: number | undefined;
  npName: string | undefined;
  npi: string | undefined;
  auditorId?: number | undefined;
  assignedTo: string | undefined;
}

export class AssessmentAuditResponsePagedResult implements IAssessmentAuditResponsePagedResult {
  items?: AssessmentAuditResponse[] | undefined;
  readonly pageIndex?: number;
  readonly pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;

  constructor(data?: IAssessmentAuditResponsePagedResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(AssessmentAuditResponse.fromJS(item));
      }
      (this as any).pageIndex = _data['pageIndex'];
      (this as any).pageSize = _data['pageSize'];
      this.totalItems = _data['totalItems'];
      (this as any).totalPages = _data['totalPages'];
      (this as any).hasPreviousPage = _data['hasPreviousPage'];
      (this as any).hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): AssessmentAuditResponsePagedResult {
    data = typeof data === 'object' ? data : {};
    let result = new AssessmentAuditResponsePagedResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    data['totalItems'] = this.totalItems;
    data['totalPages'] = this.totalPages;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IAssessmentAuditResponsePagedResult {
  items?: AssessmentAuditResponse[] | undefined;
  pageIndex?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class AssignAuditorRequest implements IAssignAuditorRequest {
  assessmentRowIds!: number[];
  auditorId!: number;
  auditTypeId!: number;

  constructor(data?: IAssignAuditorRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.assessmentRowIds = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['assessmentRowIds'])) {
        this.assessmentRowIds = [] as any;
        for (let item of _data['assessmentRowIds']) this.assessmentRowIds!.push(item);
      }
      this.auditorId = _data['auditorId'];
      this.auditTypeId = _data['auditTypeId'];
    }
  }

  static fromJS(data: any): AssignAuditorRequest {
    data = typeof data === 'object' ? data : {};
    let result = new AssignAuditorRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.assessmentRowIds)) {
      data['assessmentRowIds'] = [];
      for (let item of this.assessmentRowIds) data['assessmentRowIds'].push(item);
    }
    data['auditorId'] = this.auditorId;
    data['auditTypeId'] = this.auditTypeId;
    return data;
  }
}

export interface IAssignAuditorRequest {
  assessmentRowIds: number[];
  auditorId: number;
  auditTypeId: number;
}

export class AuditPipelineResult implements IAuditPipelineResult {
  success?: boolean;
  dumpedCount?: number;
  assignedCount?: number;
  skippedNpCount?: number;
  uncoveredNpCount?: number;
  errorMessage?: string | undefined;
  duration?: string;

  constructor(data?: IAuditPipelineResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.success = _data['success'];
      this.dumpedCount = _data['dumpedCount'];
      this.assignedCount = _data['assignedCount'];
      this.skippedNpCount = _data['skippedNpCount'];
      this.uncoveredNpCount = _data['uncoveredNpCount'];
      this.errorMessage = _data['errorMessage'];
      this.duration = _data['duration'];
    }
  }

  static fromJS(data: any): AuditPipelineResult {
    data = typeof data === 'object' ? data : {};
    let result = new AuditPipelineResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['success'] = this.success;
    data['dumpedCount'] = this.dumpedCount;
    data['assignedCount'] = this.assignedCount;
    data['skippedNpCount'] = this.skippedNpCount;
    data['uncoveredNpCount'] = this.uncoveredNpCount;
    data['errorMessage'] = this.errorMessage;
    data['duration'] = this.duration;
    return data;
  }
}

export interface IAuditPipelineResult {
  success?: boolean;
  dumpedCount?: number;
  assignedCount?: number;
  skippedNpCount?: number;
  uncoveredNpCount?: number;
  errorMessage?: string | undefined;
  duration?: string;
}

export class AuditScoreSummaryResponse implements IAuditScoreSummaryResponse {
  score?: number | undefined;
  trendPercentage?: number | undefined;
  isCurrentScoreAvailable?: boolean;
  isTrendAvailable?: boolean;

  constructor(data?: IAuditScoreSummaryResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.score = _data['score'];
      this.trendPercentage = _data['trendPercentage'];
      this.isCurrentScoreAvailable = _data['isCurrentScoreAvailable'];
      this.isTrendAvailable = _data['isTrendAvailable'];
    }
  }

  static fromJS(data: any): AuditScoreSummaryResponse {
    data = typeof data === 'object' ? data : {};
    let result = new AuditScoreSummaryResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['score'] = this.score;
    data['trendPercentage'] = this.trendPercentage;
    data['isCurrentScoreAvailable'] = this.isCurrentScoreAvailable;
    data['isTrendAvailable'] = this.isTrendAvailable;
    return data;
  }
}

export interface IAuditScoreSummaryResponse {
  score?: number | undefined;
  trendPercentage?: number | undefined;
  isCurrentScoreAvailable?: boolean;
  isTrendAvailable?: boolean;
}

export class AuditedAssessmentResponse implements IAuditedAssessmentResponse {
  auditId?: number;
  assessmentId?: number;
  clientId?: number;
  clientName?: string | undefined;
  memberId?: number;
  memberName?: string | undefined;
  encounterDate?: string | undefined;
  interventionTypeId?: number | undefined;
  vendorId?: number;
  auditScore?: number | undefined;
  createdDate?: string;

  constructor(data?: IAuditedAssessmentResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.auditId = _data['auditId'];
      this.assessmentId = _data['assessmentId'];
      this.clientId = _data['clientId'];
      this.clientName = _data['clientName'];
      this.memberId = _data['memberId'];
      this.memberName = _data['memberName'];
      this.encounterDate = _data['encounterDate'];
      this.interventionTypeId = _data['interventionTypeId'];
      this.vendorId = _data['vendorId'];
      this.auditScore = _data['auditScore'];
      this.createdDate = _data['createdDate'];
    }
  }

  static fromJS(data: any): AuditedAssessmentResponse {
    data = typeof data === 'object' ? data : {};
    let result = new AuditedAssessmentResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['auditId'] = this.auditId;
    data['assessmentId'] = this.assessmentId;
    data['clientId'] = this.clientId;
    data['clientName'] = this.clientName;
    data['memberId'] = this.memberId;
    data['memberName'] = this.memberName;
    data['encounterDate'] = this.encounterDate;
    data['interventionTypeId'] = this.interventionTypeId;
    data['vendorId'] = this.vendorId;
    data['auditScore'] = this.auditScore;
    data['createdDate'] = this.createdDate;
    return data;
  }
}

export interface IAuditedAssessmentResponse {
  auditId?: number;
  assessmentId?: number;
  clientId?: number;
  clientName?: string | undefined;
  memberId?: number;
  memberName?: string | undefined;
  encounterDate?: string | undefined;
  interventionTypeId?: number | undefined;
  vendorId?: number;
  auditScore?: number | undefined;
  createdDate?: string;
}

export class CompletedAssessmentAuditResponse implements ICompletedAssessmentAuditResponse {
  assessmentAuditRowId?: number;
  assessmentRowId?: number;
  assessmentId?: number;
  clientId?: number;
  lobId?: number | undefined;
  clientName?: string | undefined;
  clientMemberId!: string | undefined;
  npName!: string | undefined;
  npi!: string | undefined;
  interventionTypeId?: number | undefined;
  appointmentDate?: string | undefined;
  memberName?: string | undefined;
  memberId?: number | undefined;
  gender!: string | undefined;
  age?: number | undefined;
  auditTypeId?: number | undefined;
  auditDate?: string | undefined;

  constructor(data?: ICompletedAssessmentAuditResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assessmentAuditRowId = _data['assessmentAuditRowId'];
      this.assessmentRowId = _data['assessmentRowId'];
      this.assessmentId = _data['assessmentId'];
      this.clientId = _data['clientId'];
      this.lobId = _data['lobId'];
      this.clientName = _data['clientName'];
      this.clientMemberId = _data['clientMemberId'];
      this.npName = _data['npName'];
      this.npi = _data['npi'];
      this.interventionTypeId = _data['interventionTypeId'];
      this.appointmentDate = _data['appointmentDate'];
      this.memberName = _data['memberName'];
      this.memberId = _data['memberId'];
      this.gender = _data['gender'];
      this.age = _data['age'];
      this.auditTypeId = _data['auditTypeId'];
      this.auditDate = _data['auditDate'];
    }
  }

  static fromJS(data: any): CompletedAssessmentAuditResponse {
    data = typeof data === 'object' ? data : {};
    let result = new CompletedAssessmentAuditResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['assessmentAuditRowId'] = this.assessmentAuditRowId;
    data['assessmentRowId'] = this.assessmentRowId;
    data['assessmentId'] = this.assessmentId;
    data['clientId'] = this.clientId;
    data['lobId'] = this.lobId;
    data['clientName'] = this.clientName;
    data['clientMemberId'] = this.clientMemberId;
    data['npName'] = this.npName;
    data['npi'] = this.npi;
    data['interventionTypeId'] = this.interventionTypeId;
    data['appointmentDate'] = this.appointmentDate;
    data['memberName'] = this.memberName;
    data['memberId'] = this.memberId;
    data['gender'] = this.gender;
    data['age'] = this.age;
    data['auditTypeId'] = this.auditTypeId;
    data['auditDate'] = this.auditDate;
    return data;
  }
}

export interface ICompletedAssessmentAuditResponse {
  assessmentAuditRowId?: number;
  assessmentRowId?: number;
  assessmentId?: number;
  clientId?: number;
  lobId?: number | undefined;
  clientName?: string | undefined;
  clientMemberId: string | undefined;
  npName: string | undefined;
  npi: string | undefined;
  interventionTypeId?: number | undefined;
  appointmentDate?: string | undefined;
  memberName?: string | undefined;
  memberId?: number | undefined;
  gender: string | undefined;
  age?: number | undefined;
  auditTypeId?: number | undefined;
  auditDate?: string | undefined;
}

export class CompletedAssessmentAuditResponsePagedResult implements ICompletedAssessmentAuditResponsePagedResult {
  items?: CompletedAssessmentAuditResponse[] | undefined;
  readonly pageIndex?: number;
  readonly pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;

  constructor(data?: ICompletedAssessmentAuditResponsePagedResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(CompletedAssessmentAuditResponse.fromJS(item));
      }
      (this as any).pageIndex = _data['pageIndex'];
      (this as any).pageSize = _data['pageSize'];
      this.totalItems = _data['totalItems'];
      (this as any).totalPages = _data['totalPages'];
      (this as any).hasPreviousPage = _data['hasPreviousPage'];
      (this as any).hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): CompletedAssessmentAuditResponsePagedResult {
    data = typeof data === 'object' ? data : {};
    let result = new CompletedAssessmentAuditResponsePagedResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    data['totalItems'] = this.totalItems;
    data['totalPages'] = this.totalPages;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface ICompletedAssessmentAuditResponsePagedResult {
  items?: CompletedAssessmentAuditResponse[] | undefined;
  pageIndex?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class HealthCheckResponse implements IHealthCheckResponse {
  status?: string | undefined;
  timestamp?: string;
  version?: string | undefined;
  environment?: string | undefined;
  details?: { [key: string]: string } | undefined;

  constructor(data?: IHealthCheckResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.status = _data['status'];
      this.timestamp = _data['timestamp'];
      this.version = _data['version'];
      this.environment = _data['environment'];
      if (_data['details']) {
        this.details = {} as any;
        for (let key in _data['details']) {
          if (_data['details'].hasOwnProperty(key)) (this.details as any)![key] = _data['details'][key];
        }
      }
    }
  }

  static fromJS(data: any): HealthCheckResponse {
    data = typeof data === 'object' ? data : {};
    let result = new HealthCheckResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['status'] = this.status;
    data['timestamp'] = this.timestamp;
    data['version'] = this.version;
    data['environment'] = this.environment;
    if (this.details) {
      data['details'] = {};
      for (let key in this.details) {
        if (this.details.hasOwnProperty(key)) (data['details'] as any)[key] = (this.details as any)[key];
      }
    }
    return data;
  }
}

export interface IHealthCheckResponse {
  status?: string | undefined;
  timestamp?: string;
  version?: string | undefined;
  environment?: string | undefined;
  details?: { [key: string]: string } | undefined;
}

export class PendingAssessmentAuditResponseAudit implements IPendingAssessmentAuditResponseAudit {
  assessmentAuditRowId?: number;
  assessmentRowId?: number;
  assessmentId?: number;
  clientId?: number;
  lobId?: number | undefined;
  clientName?: string | undefined;
  clientMemberId!: string | undefined;
  interventionTypeId?: number | undefined;
  appointmentDate?: string | undefined;
  memberName?: string | undefined;
  npName?: string | undefined;
  memberId?: number | undefined;
  gender!: string | undefined;
  age?: number | undefined;
  auditStatusId?: number | undefined;
  auditTypeId?: number | undefined;

  constructor(data?: IPendingAssessmentAuditResponseAudit) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assessmentAuditRowId = _data['assessmentAuditRowId'];
      this.assessmentRowId = _data['assessmentRowId'];
      this.assessmentId = _data['assessmentId'];
      this.clientId = _data['clientId'];
      this.lobId = _data['lobId'];
      this.clientName = _data['clientName'];
      this.clientMemberId = _data['clientMemberId'];
      this.interventionTypeId = _data['interventionTypeId'];
      this.appointmentDate = _data['appointmentDate'];
      this.memberName = _data['memberName'];
      this.npName = _data['npName'];
      this.memberId = _data['memberId'];
      this.gender = _data['gender'];
      this.age = _data['age'];
      this.auditStatusId = _data['auditStatusId'];
      this.auditTypeId = _data['auditTypeId'];
    }
  }

  static fromJS(data: any): PendingAssessmentAuditResponseAudit {
    data = typeof data === 'object' ? data : {};
    let result = new PendingAssessmentAuditResponseAudit();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['assessmentAuditRowId'] = this.assessmentAuditRowId;
    data['assessmentRowId'] = this.assessmentRowId;
    data['assessmentId'] = this.assessmentId;
    data['clientId'] = this.clientId;
    data['lobId'] = this.lobId;
    data['clientName'] = this.clientName;
    data['clientMemberId'] = this.clientMemberId;
    data['interventionTypeId'] = this.interventionTypeId;
    data['appointmentDate'] = this.appointmentDate;
    data['memberName'] = this.memberName;
    data['npName'] = this.npName;
    data['memberId'] = this.memberId;
    data['gender'] = this.gender;
    data['age'] = this.age;
    data['auditStatusId'] = this.auditStatusId;
    data['auditTypeId'] = this.auditTypeId;
    return data;
  }
}

export interface IPendingAssessmentAuditResponseAudit {
  assessmentAuditRowId?: number;
  assessmentRowId?: number;
  assessmentId?: number;
  clientId?: number;
  lobId?: number | undefined;
  clientName?: string | undefined;
  clientMemberId: string | undefined;
  interventionTypeId?: number | undefined;
  appointmentDate?: string | undefined;
  memberName?: string | undefined;
  npName?: string | undefined;
  memberId?: number | undefined;
  gender: string | undefined;
  age?: number | undefined;
  auditStatusId?: number | undefined;
  auditTypeId?: number | undefined;
}

export class PendingAssessmentAuditResponseAuditPagedResult implements IPendingAssessmentAuditResponseAuditPagedResult {
  items?: PendingAssessmentAuditResponseAudit[] | undefined;
  readonly pageIndex?: number;
  readonly pageSize?: number;
  totalItems?: number;
  readonly totalPages?: number;
  readonly hasPreviousPage?: boolean;
  readonly hasNextPage?: boolean;

  constructor(data?: IPendingAssessmentAuditResponseAuditPagedResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(PendingAssessmentAuditResponseAudit.fromJS(item));
      }
      (this as any).pageIndex = _data['pageIndex'];
      (this as any).pageSize = _data['pageSize'];
      this.totalItems = _data['totalItems'];
      (this as any).totalPages = _data['totalPages'];
      (this as any).hasPreviousPage = _data['hasPreviousPage'];
      (this as any).hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PendingAssessmentAuditResponseAuditPagedResult {
    data = typeof data === 'object' ? data : {};
    let result = new PendingAssessmentAuditResponseAuditPagedResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item ? item.toJSON() : (undefined as any));
    }
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    data['totalItems'] = this.totalItems;
    data['totalPages'] = this.totalPages;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPendingAssessmentAuditResponseAuditPagedResult {
  items?: PendingAssessmentAuditResponseAudit[] | undefined;
  pageIndex?: number;
  pageSize?: number;
  totalItems?: number;
  totalPages?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data['type'];
      this.title = _data['title'];
      this.status = _data['status'];
      this.detail = _data['detail'];
      this.instance = _data['instance'];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['type'] = this.type;
    data['title'] = this.title;
    data['status'] = this.status;
    data['detail'] = this.detail;
    data['instance'] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class QuestionnaireIdsResponse implements IQuestionnaireIdsResponse {
  auditPublishedQuestionnaireId?: string | undefined;
  auditPublishedQuestionnaireResponseId?: string | undefined;
  assessmentPublishedQuestionnaireId?: string | undefined;
  assessmentQuestionnaireResponseId?: string | undefined;
  assessmentVersionId?: number | undefined;
  assessmentVersion?: number | undefined;

  constructor(data?: IQuestionnaireIdsResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.auditPublishedQuestionnaireId = _data['auditPublishedQuestionnaireId'];
      this.auditPublishedQuestionnaireResponseId = _data['auditPublishedQuestionnaireResponseId'];
      this.assessmentPublishedQuestionnaireId = _data['assessmentPublishedQuestionnaireId'];
      this.assessmentQuestionnaireResponseId = _data['assessmentQuestionnaireResponseId'];
      this.assessmentVersionId = _data['assessmentVersionId'];
      this.assessmentVersion = _data['assessmentVersion'];
    }
  }

  static fromJS(data: any): QuestionnaireIdsResponse {
    data = typeof data === 'object' ? data : {};
    let result = new QuestionnaireIdsResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['auditPublishedQuestionnaireId'] = this.auditPublishedQuestionnaireId;
    data['auditPublishedQuestionnaireResponseId'] = this.auditPublishedQuestionnaireResponseId;
    data['assessmentPublishedQuestionnaireId'] = this.assessmentPublishedQuestionnaireId;
    data['assessmentQuestionnaireResponseId'] = this.assessmentQuestionnaireResponseId;
    data['assessmentVersionId'] = this.assessmentVersionId;
    data['assessmentVersion'] = this.assessmentVersion;
    return data;
  }
}

export interface IQuestionnaireIdsResponse {
  auditPublishedQuestionnaireId?: string | undefined;
  auditPublishedQuestionnaireResponseId?: string | undefined;
  assessmentPublishedQuestionnaireId?: string | undefined;
  assessmentQuestionnaireResponseId?: string | undefined;
  assessmentVersionId?: number | undefined;
  assessmentVersion?: number | undefined;
}

export class SearchSortParams implements ISearchSortParams {
  searchText?: string | undefined;
  searchColumns?: string[] | undefined;
  sortColumn?: string | undefined;
  sortDirection?: string | undefined;

  constructor(data?: ISearchSortParams) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.searchText = _data['searchText'];
      if (Array.isArray(_data['searchColumns'])) {
        this.searchColumns = [] as any;
        for (let item of _data['searchColumns']) this.searchColumns!.push(item);
      }
      this.sortColumn = _data['sortColumn'];
      this.sortDirection = _data['sortDirection'];
    }
  }

  static fromJS(data: any): SearchSortParams {
    data = typeof data === 'object' ? data : {};
    let result = new SearchSortParams();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['searchText'] = this.searchText;
    if (Array.isArray(this.searchColumns)) {
      data['searchColumns'] = [];
      for (let item of this.searchColumns) data['searchColumns'].push(item);
    }
    data['sortColumn'] = this.sortColumn;
    data['sortDirection'] = this.sortDirection;
    return data;
  }
}

export interface ISearchSortParams {
  searchText?: string | undefined;
  searchColumns?: string[] | undefined;
  sortColumn?: string | undefined;
  sortDirection?: string | undefined;
}

export class UpdateAuditRequest implements IUpdateAuditRequest {
  assessmentAuditRowId!: number;
  auditStatusId?: number | undefined;
  auditTypeId?: number | undefined;
  auditorId?: number | undefined;
  publishedQuestionnaireResponseId?: string | undefined;
  score?: number | undefined;

  constructor(data?: IUpdateAuditRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assessmentAuditRowId = _data['assessmentAuditRowId'];
      this.auditStatusId = _data['auditStatusId'];
      this.auditTypeId = _data['auditTypeId'];
      this.auditorId = _data['auditorId'];
      this.publishedQuestionnaireResponseId = _data['publishedQuestionnaireResponseId'];
      this.score = _data['score'];
    }
  }

  static fromJS(data: any): UpdateAuditRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateAuditRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['assessmentAuditRowId'] = this.assessmentAuditRowId;
    data['auditStatusId'] = this.auditStatusId;
    data['auditTypeId'] = this.auditTypeId;
    data['auditorId'] = this.auditorId;
    data['publishedQuestionnaireResponseId'] = this.publishedQuestionnaireResponseId;
    data['score'] = this.score;
    return data;
  }
}

export interface IUpdateAuditRequest {
  assessmentAuditRowId: number;
  auditStatusId?: number | undefined;
  auditTypeId?: number | undefined;
  auditorId?: number | undefined;
  publishedQuestionnaireResponseId?: string | undefined;
  score?: number | undefined;
}

export class SwaggerException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
